import { combineReducers } from 'redux'

import sessionReducer from './sessionReducer'
import newCampaignReducer from './newCampaignReducer'
import signupReducer from './signupReducer'
import unsavedReducer from './unsavedReducer'
import creditcardsReducer from './creditcardsReducer'
import campaignReducer from './campaignReducer'
import dashboardReducer from './dashboardReducer'
import analyticsReducer from './analyticsReducer'
import adminsReducer from './adminsReducer'
import editPlacementsReducer from './editPlacementsReducer'
import superAdminReducer from './SuperAdminReducer'

const rootReducer = combineReducers({
  session: sessionReducer,
  newCampaign: newCampaignReducer,
  signup: signupReducer,
  unsaved: unsavedReducer,
  creditCards: creditcardsReducer,
  campaigns: campaignReducer,
  dashboard: dashboardReducer,
  analytics: analyticsReducer,
  admins: adminsReducer,
  editPlacements: editPlacementsReducer,
  superAdmin: superAdminReducer
})

export default rootReducer
